import { Button } from "@mui/material";
import Sidecontents from "./Sidecontents";
import { useState } from "react";
import sidebarimg from "./images/best4.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { HbrBroadcast, HbrCancel } from "./MyCustomsvgicons";

const Admindashboard = () => {
 
    const[showProfilePane,setProfilePane]=useState(false);
    const[showLivesettings,setShowLivesettings]=useState(false);
    const[showStats,setShowStats]=useState(false);
    const[showAnnouncemwntpanel,setshowAnouncementpanel]=useState(false);
    const[showApprovalpanel,setshowApprovalpanel]=useState(false);
    const[showCreateevent,setShowCreateevent]=useState(false);
    const[showOverview,setShowOverview]=useState(true);
    const navigate = useNavigate("");
    const location = useLocation();
 

    const handleCloseAllSessions=()=>{
      setShowLivesettings(false);
      setProfilePane(false);
      setShowStats(false);
      setshowAnouncementpanel(false);
      setshowApprovalpanel(false);
      setShowCreateevent(false);
      setShowOverview(true);
    };
    const handledisplayadminprofile=()=>{
        setProfilePane(true);
        setShowLivesettings(false);
        setShowStats(false);
        setshowAnouncementpanel(false);
        setshowApprovalpanel(false);
        setShowCreateevent(false);
        setShowOverview(false);
    };
    const handleShowLivesessio=()=>{
      setShowLivesettings(true);
      setProfilePane(false);
      setShowStats(false);
      setshowAnouncementpanel(false);
      setshowApprovalpanel(false);
      setShowCreateevent(false);
      setShowOverview(false);
    };
    const handleShowStats=()=>{
      setShowLivesettings(false);
      setProfilePane(false);
      setShowStats(true);
      setshowAnouncementpanel(false);
      setshowApprovalpanel(false);
      setShowCreateevent(false);
      setShowOverview(false);
    };
    const handleshowAnouncement=()=>{
      setShowLivesettings(false);
      setProfilePane(false);
      setShowStats(false);
      setshowAnouncementpanel(true);
      setshowApprovalpanel(false);
      setShowCreateevent(false);
      setShowOverview(false);
    };
    const handleshowApproval=()=>{
      setShowLivesettings(false);
      setProfilePane(false);
      setShowStats(false);
      setshowAnouncementpanel(false);
      setshowApprovalpanel(true);
      setShowCreateevent(false);
      setShowOverview(false);
    };
    const handleshowCreateevent=()=>{
      setShowLivesettings(false);
      setProfilePane(false);
      setShowStats(false);
      setshowAnouncementpanel(false);
      setshowApprovalpanel(false);
      setShowCreateevent(true);
      setShowOverview(false);
    };
    const handlegoToReports=()=>{
        navigate("/reportingdashboard");
    };

    const closePage=()=>{
          try {
              if (location.state && location.state.from) {
                  navigate(location.state.from);
              }else{
                  navigate("/");
              }
          } catch (error) {
              console.log(error);
          }
    };




    return ( 
      <div className="admindashb">
           <div className="admin">
          
          <div className="adminsidebar" style={{backgroundImage:`url(${sidebarimg})`,backgroundPosition:"center",backgroundSize:"100%"}}>
        
            <nav className="adminsidebarcontents flex-column1">

                <div className="arrangesidebaricons flex-row2">
                  <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem">
                <path d="M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 00.707-1.707l-9-9a.999.999 0 00-1.414 0l-9 9A1 1 0 003 13zm7 7v-5h4v5h-4zm2-15.586l6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z" />
                </svg>
                <Button onClick={handleCloseAllSessions}>Overview</Button>
                </div> 

                <div className="arrangesidebaricons flex-row2">
                <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem"
                >
                <path d="M21 2H6a2 2 0 00-2 2v3H2v2h2v2H2v2h2v2H2v2h2v3a2 2 0 002 2h15a1 1 0 001-1V3a1 1 0 00-1-1zm-8 2.999c1.648 0 3 1.351 3 3A3.012 3.012 0 0113 11c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3zM19 18H7v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18z" />
                </svg>   
                <Button onClick={handledisplayadminprofile}>Set up profile</Button>
                </div> 

                <div className="arrangesidebaricons flex-row2">
                <HbrBroadcast width={"2em"} height={"2em"} fillColour={"white"}/>  
                <Button onClick={()=>navigate("/bethelcastproducer", {state: {from: location.pathname}})}>Bethel Cast</Button>
                </div> 
              
                <div className="arrangesidebaricons flex-row2">
                <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem">
                <path d="M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z" />
                <path d="M2.845 16.136l1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 009 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 001.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 00-.731-2.732l-.505-.292a7.718 7.718 0 000-2.224l.505-.292a2.002 2.002 0 00.731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0015 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 00-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 00.731 2.732l.505.292a7.683 7.683 0 000 2.223l-.505.292a2.003 2.003 0 00-.731 2.733zm3.326-2.758A5.703 5.703 0 016 12c0-.462.058-.926.17-1.378a.999.999 0 00-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 001.188-.142 6.071 6.071 0 012.384-1.399A1 1 0 0011 5.3V4h2v1.3a1 1 0 00.708.956 6.083 6.083 0 012.384 1.399.999.999 0 001.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 00-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 00.471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 00-1.188.142 6.071 6.071 0 01-2.384 1.399A1 1 0 0013 18.7l.002 1.3H11v-1.3a1 1 0 00-.708-.956 6.083 6.083 0 01-2.384-1.399.992.992 0 00-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 00.471-1.108z" />
              </svg>
                <Button onClick={handleShowLivesessio}>Live settings</Button>
                </div>

               <div className="arrangesidebaricons flex-row2">
               <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem"
                >
                <path d="M20 7h-4V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H4c-1.103 0-2 .897-2 2v9a1 1 0 001 1h18a1 1 0 001-1V9c0-1.103-.897-2-2-2zM4 11h4v8H4v-8zm6-1V4h4v15h-4v-9zm10 9h-4V9h4v10z" />
                </svg>
                <Button onClick={handleShowStats}>Statistics</Button>
                </div>
              
               <div className="arrangesidebaricons flex-row2">
               <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem"
                >
                <path d="M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 003 16v2a1 1 0 001 1h16a1 1 0 001-1v-2a.996.996 0 00-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 007 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 002.818-2H9.182A2.98 2.98 0 0012 22z" />
                </svg>
               <Button onClick={handleshowAnouncement}>Create Announcement</Button>
                </div>
              
               <div className="arrangesidebaricons flex-row2">
                <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem"
                >
                <path d="M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 004 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479zm-9.01 7.895l-3.667-3.714 1.424-1.404 2.257 2.286 4.327-4.294 1.408 1.42-5.749 5.706z" />
                </svg>
               <Button onClick={handleshowApproval}>Approvals</Button>
                </div>
               
               <div className="arrangesidebaricons flex-row2">
               <svg
                viewBox="0 0 24 24"
                fill="white"
                height="2rem"
                width="2rem"
                >
                <path d="M11 12h6v6h-6z" />
                <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z" />
                </svg>
               <Button onClick={handleshowCreateevent}>Upcoming Events</Button>
                </div>

                <div className="arrangesidebaricons flex-row2">
               <Button onClick={handlegoToReports}>Reports</Button>
                </div>

                <div className="arrangesidebaricons flex-row2">
                  <HbrCancel width={"2em"} height={"2em"} fillColour={"white"}/>
                  <Button onClick={closePage}>Exit</Button>
                </div>
            </nav>
          </div>

          <div className="adminfeed">
              <Sidecontents 
              profilepane={showProfilePane} 
              livesession={showLivesettings}
              statssession={showStats}
              anouncementsession={showAnnouncemwntpanel}
              approvalsession={showApprovalpanel}
              eventsession={showCreateevent}
              overviewdetails={showOverview}
              />
          </div>
        
    </div>
      </div>
     
     );
}
export default Admindashboard